import React, { useEffect, useState } from 'react';

const MODULE_NAME = "_89_trial_expiring_banner";

/**
 * TrialExpiringBanner fetches user account type from the backend and displays a marketing message.
 * "Continue" button goes directly to the monthly plan Stripe URL.
 * Banner can be dismissed by the user. Dismissal is stored in sessionStorage for the session.
 */
function TrialExpiringBanner() {
    const [accountType, setAccountType] = useState("");
    const [clientReferenceId, setClientReferenceId] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        // Check if already dismissed this session
        const dismissedBanners = JSON.parse(sessionStorage.getItem("dismissedBanners") || "{}");
        if (dismissedBanners.trial === true) {
            setDismissed(true);
            return;
        }

        fetch(`${process.env.REACT_APP_API_URL}/api/user-banner`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setAccountType(data.account_type || "");
                setClientReferenceId(data.user_id || null);
            })
            .catch((err) => {
                console.error("Fetch error:", err);
                setAccountType("");
                setClientReferenceId(null);
            });
    }, []);

    // Stripe monthly checkout link
    const monthlyUrl = `https://buy.stripe.com/fZu9AU87k32favKejdaEE03${clientReferenceId ? `?client_reference_id=${clientReferenceId}` : ""}`;

    const handleDismiss = () => {
        const dismissedBanners = JSON.parse(sessionStorage.getItem("dismissedBanners") || "{}");
        dismissedBanners.trial = true;
        sessionStorage.setItem("dismissedBanners", JSON.stringify(dismissedBanners));
        setDismissed(true);
    };

    if (accountType !== "trial" || dismissed) {
        return null;
    }

    return (
        <div
            className="user-banner"
            data-analytics={MODULE_NAME}
            style={{
                textAlign: "center",
                padding: "8px 16px",
                background: "rgba(255,255,255,0.05)",
                border: "none",
                borderRadius: "8px",
                margin: "8px 16px 0 16px",
                position: "relative"
            }}
        >
            <button
                onClick={handleDismiss}
                style={{
                    position: "absolute",
                    top: 8,
                    right: 12,
                    background: "transparent",
                    border: "none",
                    color: "#888",
                    fontSize: 20,
                    fontWeight: "bold",
                    cursor: "pointer",
                    zIndex: 2
                }}
                aria-label="Dismiss banner"
                title="Dismiss"
            >
                ×
            </button>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "24px", flexWrap: "wrap" }}>
                <p style={{ fontWeight: 500, color: "#4ECDC4", margin: 0, fontSize: "14px" }}>
                    You are using a trial account. Upgrade now for unlimited uploads, behavioral pattern recognition, and AI insights.
                </p>
                <a
                    href={monthlyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        padding: "6px 20px",
                        background: "#fb8500",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        textDecoration: "none",
                        fontWeight: "bold",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                    }}
                >
                    Continue
                </a>
            </div>
        </div>
    );
}

export default TrialExpiringBanner;